import { useEffect, useMemo, useRef, useState } from 'react';

import { Input } from '@/components/ui/input';
import { ELoginMethods } from '@/lib/enums';
import { useAppState } from '@/state/hooks/app.state.hook';
import { useLoginState } from '@/state/hooks/login.state.hook';

import { CustomButton } from '../../CustomButton';
import { FindPlayerId } from '../Components/FindPlayerId';
import { useTranslations } from 'next-intl';
import { useStoreBoot } from '@/api/useStoreBoot';


const DEFAULT_PLAYER_ID_MIN_LENGTH = 3;

export const LoginIdMode = () => {
  const t = useTranslations();
  const playerIdInput = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState('');
  const { initialBoot } = useAppState();
  const { getBoot } = useStoreBoot();
  const { isLoggingIn, setLoginType, shouldDisableLoginButtons, loginResponse } = useLoginState();

  const theme = initialBoot?.theme;
  const playerIdPlaceholder = useMemo(
    () => theme?.loginPopup?.playerIdButton?.text?.replace(/^login with\s+/i, '') || t('portal.login.playerId'),
    [theme?.loginPopup?.playerIdButton?.text, t]
  );

  const storeBootData = getBoot?.data;
  const minLength = storeBootData?.storeTheme?.storeSettings?.playerIdMinLength ?? DEFAULT_PLAYER_ID_MIN_LENGTH;
  const isDisabled = inputValue.trim().length < minLength || shouldDisableLoginButtons || isLoggingIn;

  useEffect(() => {
    playerIdInput.current?.focus();
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();

    const playerIdValue = playerIdInput.current?.value;

    loginResponse({
      userToken: playerIdValue ?? '',
      authMethod: ELoginMethods.TOKEN
    });
  };

  return (
    <div>
      <form onSubmit={handleLogin} className='flex flex-col gap-4'>
        <Input
          ref={playerIdInput}
          type='text'
          placeholder={playerIdPlaceholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <FindPlayerId />
        <CustomButton className='w-full' onClick={() => {}} type='submit' disabled={isDisabled}>
          {t('portal.login.login')}
        </CustomButton>
        <button
          className='text-center text-sm'
          style={{ color: theme?.loginPopup?.fontColor || '#FFF' }}
          onClick={() => setLoginType(null)}
          type='button'>
          {t('portal.login.back')}
        </button>
      </form>
    </div>
  );
};
